import { InfoSmall500Style } from '../../../../styles/Text.styles'
import styled from '@emotion/styled'

export const ClientExternalLabel = styled.div`
  ${InfoSmall500Style}
`

// Horizontal radio and text
export const HStackRadioComplex = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-direction: row;
  align-items: center;
`
